import { css as _css } from "@emotion/react";
import _pt from "prop-types";
import tokens from '@datacamp/waffles-tokens';
import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";

var Body = function Body(_ref) {
  var children = _ref.children;
  return ___EmotionJSX("div", {
    css: /*#__PURE__*/_css({
      flex: 'auto',
      overflowY: 'auto',
      paddingBottom: tokens.spacing.large,
      paddingLeft: tokens.spacing.large,
      paddingRight: tokens.spacing.large
    }, process.env.NODE_ENV === "production" ? "" : ";label:Body;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zaGFyZWQvQm9keS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBYUkiLCJmaWxlIjoiLi4vLi4vc3JjL3NoYXJlZC9Cb2R5LnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB0b2tlbnMgZnJvbSAnQGRhdGFjYW1wL3dhZmZsZXMtdG9rZW5zJztcbmltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5cbmV4cG9ydCBpbnRlcmZhY2UgQm9keVByb3BzIHtcbiAgLyoqXG4gICAqIFRoZSBjb250ZW50IHRvIHJlbmRlciBpbnNpZGUgdGhlIERpYWxvZy4gU2hvdWxkIGJlIHVzZWQgYWxvbmcgd2l0aFxuICAgKiBgRGlhbG9nLkhlYWRlcmAuXG4gICAqL1xuICBjaGlsZHJlbjogUmVhY3QuUmVhY3ROb2RlO1xufVxuXG5jb25zdCBCb2R5ID0gKHsgY2hpbGRyZW4gfTogQm9keVByb3BzKTogSlNYLkVsZW1lbnQgPT4gKFxuICA8ZGl2XG4gICAgY3NzPXt7XG4gICAgICBmbGV4OiAnYXV0bycsXG4gICAgICBvdmVyZmxvd1k6ICdhdXRvJyxcbiAgICAgIHBhZGRpbmdCb3R0b206IHRva2Vucy5zcGFjaW5nLmxhcmdlLFxuICAgICAgcGFkZGluZ0xlZnQ6IHRva2Vucy5zcGFjaW5nLmxhcmdlLFxuICAgICAgcGFkZGluZ1JpZ2h0OiB0b2tlbnMuc3BhY2luZy5sYXJnZSxcbiAgICB9fVxuICAgIHRhYkluZGV4PXswfSAvLyBtdXN0IGJlIGZvY3VzYWJsZSB0byBhbGxvdyBrZXlib2FyZCBzY3JvbGxpbmdcbiAgPlxuICAgIHtjaGlsZHJlbn1cbiAgPC9kaXY+XG4pO1xuXG5leHBvcnQgZGVmYXVsdCBCb2R5O1xuIl19 */"),
    tabIndex: 0 // must be focusable to allow keyboard scrolling

  }, children);
};

Body.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _pt.node.isRequired
} : {};
export default Body;